import { render, staticRenderFns } from "./MonthlyStlmt.vue?vue&type=template&id=6fba8210"
import script from "./MonthlyStlmt.vue?vue&type=script&lang=js"
export * from "./MonthlyStlmt.vue?vue&type=script&lang=js"
import style0 from "./MonthlyStlmt.vue?vue&type=style&index=0&id=6fba8210&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fba8210')) {
      api.createRecord('6fba8210', component.options)
    } else {
      api.reload('6fba8210', component.options)
    }
    module.hot.accept("./MonthlyStlmt.vue?vue&type=template&id=6fba8210", function () {
      api.rerender('6fba8210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/settlement/MonthlyStlmt.vue"
export default component.exports